import { render, staticRenderFns } from "./ProductButtonComponent.vue?vue&type=template&id=3cd32001&"
import script from "./ProductButtonComponent.vue?vue&type=script&lang=ts&"
export * from "./ProductButtonComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductButtonComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports